import Config from "../../utils/Config";
import {
  apiClient,
  decoded,
} from '../../utils';

export const apiRequest = ({
  url,
  method = 'get',
  headers = {},
  body = null,
  successType,
  errorType,
  successMessage = '',
  loadingType = 'LOADING',
  transformResponse = (data) => data,
}) => {
  return async (dispatch) => {
    if (loadingType) {
      dispatch({ type: loadingType, payload: true });
    }

    try {
      const config = {
        method,
        url,
        headers: {
          ...Config.getHeaders(),
          ...headers,
        },
      };

      if (body && method.toLowerCase() !== 'get') {
        config.data = body;
      }

      const response = await apiClient(config);
      const transformedData = transformResponse(response.data, dispatch);

      if (successType) {
        dispatch({ type: successType, payload: transformedData });
      }

      return transformedData; // useful for chaining
    } catch (error) {
      if (errorType) {
        dispatch({ type: errorType, payload: error });
      }

      dispatch({
        type: 'ERROR_MESSAGE',
        payload: error?.response?.data?.message || `${url} failed`,
      });
    } finally {
      const payload = url.includes("/") ? url.split("/")[2] : url;
      dispatch({ type: 'SUCCESS_MESSAGE', payload });   
      if (loadingType) {
        dispatch({ type: loadingType, payload: false });
      }
    }
  };
};
